import { actions } from './actions'

const initialState = {
  stickers: {
    data: [],
    loading: false,
    error: '',
  },
  categoriasStickers: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function stickersReducer(state = initialState, action) {
  switch (action.type) {
    case actions.STICKERS_LOAD_REQUESTED:
      return { ...state, stickers: { ...state.stickers, loading: true } }
    case actions.STICKERS_LOAD_SUCCEEDED:
      return {
        ...state,
        stickers: { ...state.stickers, data: action.payload, loading: false },
      }
    case actions.STICKERS_LOAD_FAILED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: false, error: action.error },
      }
    case actions.STICKERS_CATEGORIA_LOAD_REQUESTED:
      return { ...state, stickers: { ...state.stickers, loading: true } }
    case actions.STICKERS_CATEGORIA_LOAD_SUCCEEDED:
      return {
        ...state,
        stickers: { ...state.stickers, data: action.payload, loading: false },
      }
    case actions.STICKERS_CATEGORIA_LOAD_FAILED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: false, error: action.error },
      }
    case actions.STICKERS_INSERT_REQUESTED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: true, error: '' },
      }
    case actions.STICKERS_INSERT_SUCCEEDED:
      return {
        ...state,
        stickers: {
          ...state.stickers,
          data: [...state.stickers.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.STICKERS_INSERT_FAILED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: false, error: action.error },
      }

    case actions.STICKERS_UPDATE_REQUESTED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: true, error: '' },
      }
    case actions.STICKERS_UPDATE_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const updated = state.stickers.data.map(sticker => {
        if (sticker.id === action.payload.id) {
          return action.payload
        }
        return sticker
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        stickers: {
          ...state.stickers,
          data: updated,
          loading: false,
          error: '',
        },
      }
    case actions.STICKERS_UPDATE_FAILED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: false, error: action.error },
      }

    case actions.STICKERS_DELETE_REQUESTED:
      return { ...state, stickers: { ...state.stickers, loading: true } }
    case actions.STICKERS_DELETE_SUCCEEDED:
      return {
        ...state,
        stickers: {
          ...state.stickers,
          loading: false,
          data: state.stickers.data.filter(sticker => sticker.id !== action.id),
        },
      }
    case actions.STICKERS_DELETE_FAILED:
      return {
        ...state,
        stickers: { ...state.stickers, loading: false },
      }

    case actions.CATEGORIAS_STICKERS_LOAD_REQUESTED:
      return { ...state, categoriasStickers: { ...state.categoriasStickers, loading: true } }
    case actions.CATEGORIAS_STICKERS_LOAD_SUCCEEDED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, data: action.payload, loading: false },
      }
    case actions.CATEGORIAS_STICKERS_LOAD_FAILED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: false, error: action.error },
      }

    case actions.CATEGORIAS_STICKERS_INSERT_REQUESTED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: true, error: '' },
      }
    case actions.CATEGORIAS_STICKERS_INSERT_SUCCEEDED:
      return {
        ...state,
        categoriasStickers: {
          ...state.categoriasStickers,
          data: [...state.categoriasStickers.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.CATEGORIAS_STICKERS_INSERT_FAILED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: false, error: action.error },
      }

    case actions.CATEGORIAS_STICKERS_UPDATE_REQUESTED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: true, error: '' },
      }
    case actions.CATEGORIAS_STICKERS_UPDATE_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const updatedData = state.categoriasStickers.data.map(sticker => {
        if (sticker.id === action.payload.id) {
          return action.payload
        }
        return sticker
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        categoriasStickers: {
          ...state.categoriasStickers,
          data: updatedData,
          loading: false,
          error: '',
        },
      }
    case actions.CATEGORIAS_STICKERS_UPDATE_FAILED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: false, error: action.error },
      }

    case actions.CATEGORIAS_STICKERS_DELETE_REQUESTED:
      return { ...state, categoriasStickers: { ...state.categoriasStickers, loading: true } }
    case actions.CATEGORIAS_STICKERS_DELETE_SUCCEEDED:
      return {
        ...state,
        categoriasStickers: {
          ...state.categoriasStickers,
          loading: false,
          data: state.categoriasStickers.data.filter(sticker => sticker.id !== action.payload),
        },
      }
    case actions.CATEGORIAS_STICKERS_DELETE_FAILED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: false },
      }
    case actions.CATEGORIAS_STICKERS_RESET_COUNTER_REQUESTED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: true, error: '' },
      }
    case actions.CATEGORIAS_STICKERS_RESET_COUNTER_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const resetedCounter = state.categoriasStickers.data.map(sticker => {
        if (sticker.id === action.payload.id) {
          return action.payload
        }
        return sticker
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        categoriasStickers: {
          ...state.categoriasStickers,
          data: resetedCounter,
          loading: false,
          error: '',
        },
      }
    case actions.CATEGORIAS_STICKERS_RESET_COUNTER_FAILED:
      return {
        ...state,
        categoriasStickers: { ...state.categoriasStickers, loading: false, error: action.error },
      }
    default:
      return state
  }
}
